import { render } from "./ResultsIndicators.vue?vue&type=template&id=64c93e29&scoped=true&lang=pug"
import script from "./ResultsIndicators.vue?vue&type=script&lang=js"
export * from "./ResultsIndicators.vue?vue&type=script&lang=js"

import "./ResultsIndicators.vue?vue&type=style&index=0&id=64c93e29&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c93e29"]])

export default __exports__